/* Navigation mirrors GHL; SERVICES/EVENTS are buttons, commerce stays on Shopify. */
(() => {
  document.documentElement.classList.replace('no-js', 'js');
  const dropdowns = () => [...document.querySelectorAll('[data-pt-dropdown]')];
  const trigger = item => item.querySelector('.pt-nav__dropdown-trigger');
  const closeDropdowns = except => dropdowns().forEach(item => {
    if (item === except) return;
    item.classList.remove('is-open');
    item.classList.add('is-dismissed');
    trigger(item)?.setAttribute('aria-expanded', 'false');
  });
  function openDropdown(item, sticky = false) {
    closeDropdowns(item);
    item.classList.remove('is-dismissed');
    if (sticky) item.classList.add('is-open');
    trigger(item)?.setAttribute('aria-expanded', 'true');
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const item = event.target.closest('[data-pt-dropdown]');
    if (item && !item.contains(event.relatedTarget)) openDropdown(item);
  });
  document.addEventListener('pointerout', event => {
    const item = event.target.closest('[data-pt-dropdown]');
    if (item && !item.contains(event.relatedTarget) && !item.contains(document.activeElement)) {
      item.classList.remove('is-open');
      trigger(item)?.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('focusin', event => {
    const item = event.target.closest('[data-pt-dropdown]');
    if (item) openDropdown(item);
  });
  document.addEventListener('focusout', event => {
    const item = event.target.closest('[data-pt-dropdown]');
    if (item && !item.contains(event.relatedTarget) && !item.matches(':hover')) closeDropdowns();
  });
  function setMobile(button, open) {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  }
  const closeMobile = () => document.querySelectorAll('[data-pt-mobile-toggle]').forEach(button => setMobile(button, false));
  let activeSearch, searchOpener, previousOverflow;
  function closeSearch(restoreFocus = true) {
    if (!activeSearch) return;
    activeSearch.hidden = true;
    document.body.classList.remove('pt-search-lock');
    document.body.style.overflow = previousOverflow;
    document.querySelectorAll('[data-pt-search-background]').forEach(el => { el.inert = false; el.removeAttribute('data-pt-search-background'); });
    activeSearch = null;
    if (restoreFocus && searchOpener?.isConnected) searchOpener.focus();
  }
  document.addEventListener('click', event => {
    const dropdownButton = event.target.closest('.pt-nav__dropdown-trigger');
    if (dropdownButton) {
      const item = dropdownButton.closest('[data-pt-dropdown]');
      if (item.classList.contains('is-open')) closeDropdowns();
      else openDropdown(item, true);
      return;
    }
    if (!event.target.closest('[data-pt-dropdown]')) closeDropdowns();
    const menuButton = event.target.closest('[data-pt-mobile-toggle]');
    if (menuButton) { setMobile(menuButton, menuButton.getAttribute('aria-expanded') !== 'true'); return; }
    if (!event.target.closest('[data-pt-header]') || event.target.closest('.pt-mobile-menu__panel a')) closeMobile();
    const opener = event.target.closest('[data-pt-search-open]');
    if (opener) {
      closeSearch(false);
      closeMobile();
      const overlay = document.getElementById(opener.getAttribute('aria-controls'));
      if (!overlay) return;
      searchOpener = opener;
      activeSearch = overlay;
      previousOverflow = document.body.style.overflow;
      overlay.hidden = false;
      document.body.classList.add('pt-search-lock');
      // Inert the background, keeping the dialog and its ancestors interactive.
      let node = overlay;
      while (node.parentElement && node.parentElement !== document.documentElement) {
        [...node.parentElement.children].forEach(sibling => {
          if (sibling !== node && !sibling.inert && !['SCRIPT','STYLE','NOSCRIPT'].includes(sibling.tagName)) {
            sibling.inert = true; sibling.setAttribute('data-pt-search-background','');
          }
        });
        node = node.parentElement;
      }
      const input = overlay.querySelector('[name=q]');
      if (input) { input.value = ''; input.dispatchEvent(new Event('input', {bubbles:true})); input.focus(); }
      return;
    }
    if (event.target.closest('[data-pt-search-close]')) closeSearch();
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('.pt-search-overlay__input')) return;
    const overlay = event.target.closest('[data-pt-search-overlay]');
    const hasQuery = Boolean(event.target.value.trim());
    overlay.querySelector('.pt-search-overlay__explore').hidden = hasQuery;
    overlay.querySelector('.pt-search-overlay__results').hidden = !hasQuery;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (activeSearch) { closeSearch(); return; }
      const focusedDropdown = event.target.closest('[data-pt-dropdown]');
      closeDropdowns();
      if (focusedDropdown) trigger(focusedDropdown)?.focus();
      // focusin can reopen the panel; dismiss after restoring focus.
      closeDropdowns();
      const mobileButton = document.querySelector('[data-pt-mobile-toggle][aria-expanded=true]');
      closeMobile();
      if (mobileButton) mobileButton.focus();
      return;
    }
    const dropdownButton = event.target.closest('.pt-nav__dropdown-trigger');
    if (dropdownButton && event.key === 'ArrowDown') {
      event.preventDefault();
      const item = dropdownButton.closest('[data-pt-dropdown]');
      openDropdown(item, true);
      item.querySelector('.pt-nav-dropdown__panel a')?.focus();
    }
    if (event.key !== 'Tab' || !activeSearch) return;
    const focusable = [...activeSearch.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el => el.getClientRects().length && !el.classList.contains('visually-hidden'));
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
  });
  window.matchMedia('(min-width:768px)').addEventListener('change', closeMobile);
  document.addEventListener('shopify:section:unload', () => closeSearch(false));
})();
